import _get from 'lodash/get';

export const getCurrentFolderId = state => _get(state, ['templates', 'currentFolder', 'id']);
export const getLocation = state => _get(state, ['router', 'location'], {});
